import React, { useState, useEffect } from 'react'
import { Button, Input } from 'antd'
import { LogoutOutlined } from '@ant-design/icons'
import { navigate } from '@reach/router'
import moment from 'moment'

import httpRequest from '../../services/http-request'
import LoadingSpinner from '../common/loading-spinner'

const IpReport = (props) => {
  const [loading, setLoading] = useState(false)
  const [ip, setIp] = useState('')
  const [loginName, setLoginName] = useState('')
  const [marketId, setMarketId] = useState('')
  const [result, setResult] = useState(null)
  const [userName, setUserName] = useState('')

  useEffect(() => {
    const userRole = localStorage.getItem('role')
    const loggedUserName = localStorage.getItem('userName')
    if (!userRole || !loggedUserName) {
      props.navigate('/login')
    }
    setUserName(loggedUserName)
  }, [])

  const handleLogoutClick = () => {
    localStorage.removeItem('role')
    localStorage.removeItem('token')
    navigate('/login')
  }

  const fetchIpReport = async () => {
    const abortController = new AbortController()
    const query = `/api/misc/getCommonIpReport?ip=${ip}&loginName=${loginName}&marketId=${marketId}`
    const response = await httpRequest(
      query,
      'GET',
      undefined,
      abortController.signal
    )
    console.log(response)
    setResult(response.data.result)
  }

  const handleIpChange = (event) => {
    setIp(event.target.value)
  }

  const handleLoginNameChange = (event) => {
    setLoginName(event.target.value)
  }

  const handleMarketIdChange = (event) => {
    setMarketId(event.target.value)
  }

  const handleFilterApplyClick = async () => {
    setLoading(true)
    await fetchIpReport()
    setLoading(false)
  }

  const signedValueSpan = (value) => {
    if (value < 0) {
      return (
        <span className="value-span value-span--value-negative">
          {parseFloat(value).toFixed(2)}
        </span>
      )
    } else {
      return (
        <span className="value-span value-span--value-positive">
          {parseFloat(value).toFixed(2)}
        </span>
      )
    }
  }

  const valueSpan = (value) => {
    return <span className="value-span">{parseFloat(value).toFixed(2)}</span>
  }

  return (
    <>
      <div className="page-container">
        <div className="header">
          <div className="header__title">
            <h2>IP Report</h2>
            <span className="header-span--pull-right">
              <span className="user-name">{userName}</span>
              <Button onClick={handleLogoutClick} type="primary" size="small">
                Logout <LogoutOutlined />
              </Button>
            </span>
          </div>
          <div className="header__filters">
            <span className="filter">
              <Input
                placeholder="IP"
                onChange={handleIpChange}
                style={{ width: 200 }}
              />
            </span>
            <span className="filter">
              <Input
                placeholder="Login Name"
                onChange={handleLoginNameChange}
                style={{ width: 200 }}
              />
            </span>
            <span className="filter">
              <Input
                placeholder="Market ID"
                onChange={handleMarketIdChange}
                style={{ width: 200 }}
              />
            </span>
            <span className="filter">
              <Button
                type="primary"
                onClick={handleFilterApplyClick}
                loading={loading}
              >
                Apply
              </Button>
            </span>
            <span className="filter">
              <Button type="primary" danger>
                Clear
              </Button>
            </span>
          </div>
        </div>

        {!loading && (
          <div className="data-grid">
            {/* <pre style={{ textAlign: 'left', color: '#fff' }}>
              {result && JSON.stringify(result, null, 2)}
            </pre> */}
            {result && result.header && (
              <table>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Sports Name</th>
                    <th>Competition</th>
                    <th>Event Name</th>
                    <th>Market Type</th>
                    <th>Super Master</th>
                    <th>Master</th>
                    <th>Agent</th>
                    <th>Member</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{result.header.title}</td>
                    <td>{result.header.sportsName}</td>
                    <td>{result.header.competition}</td>
                    <td>{result.header.eventName}</td>
                    <td>{result.header.marketType}</td>
                    <td>{result.header.superMaster}</td>
                    <td>{result.header.master}</td>
                    <td>{result.header.agent}</td>
                    <td>{result.header.member}</td>
                  </tr>
                </tbody>
              </table>
            )}
            {result && (
              <table style={{ marginTop: 40 }}>
                <thead>
                  <tr>
                    <th>Member Login ID</th>
                    <th>Bet IP Address</th>
                    <th>Market Name</th>
                    <th>Selection</th>
                    <th>inPlay</th>
                    <th>Type</th>
                    <th>Odds Requested</th>
                    <th>Avg Matched Odds</th>
                    <th>Stake Requested</th>
                    <th>Stake Matched</th>
                    <th>Placed</th>
                    <th>Last Matched</th>
                    <th>Status</th>
                    <th>Win Loss</th>
                  </tr>
                </thead>
                <tbody>
                  {result.table.map((r) => (
                    <tr>
                      <td>{r.memberLoginID}</td>
                      <td>{r.betIPAddress}</td>
                      <td>{r.marketName}</td>
                      <td>{r.selection}</td>
                      <td>{r.inPlay}</td>
                      <td>{r.type}</td>
                      <td>{r.oddsRequested}</td>
                      <td>{r.avgMatchedOdds}</td>
                      <td>{valueSpan(r.stakeRequested)}</td>
                      <td>{valueSpan(r.stakeMatched)}</td>
                      <td>{moment(r.placed).format('DD/MM/YYYY HH:mm:ss')}</td>
                      <td>
                        {moment(r.lastMatched).format('DD/MM/YYYY HH:mm:ss')}
                      </td>
                      <td>{r.status}</td>
                      <td>{signedValueSpan(r.winLoss)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
        {loading && <LoadingSpinner />}
      </div>
    </>
  )
}

export default IpReport
